import {isUndefined} from 'lodash';

export function getAssignedToText(assignment) {
  const classes = assignment.get('classes');

  /*
    TODO: The rules of what this copy should
    be need to be explained to me. Right now I'm only showing classes
    on purpose.

    In the future, when individual students can be given assignments,
    this will need to be updated to include those individual students.
  */
  if (!isUndefined(classes)) {
    return `${classes} ${classes === 1 ? 'class' : 'classes'}`;
  }
  return 'n/a';
}

function getProgressHeadingText(progressValue, progressEnd, completedText) {
  /*
    For both the
      getNumberCompletedHeadingForStudent and
      getNumberCompletedHeadingForTeacher functions:

    Either
     X out of Y Answered  (student)
     X out of Y Completed (teacher)
  */
  if (isUndefined(progressValue) || isUndefined(progressEnd)) {
    return completedText;
  }

  return `${progressValue} out of ${progressEnd} ${completedText}`;
}

export function getNumberCompletedHeadingForStudent(assignment) {
  const progressValue = assignment.get('progressValue');
  const progressEnd = assignment.get('progressEnd');
  const completedText = 'Answered';

  return getProgressHeadingText(progressValue, progressEnd, completedText);
}

export function getNumberCompletedHeadingForTeacher(assignment) {
  const progressValue = assignment.get('progressValue');
  const progressEnd = assignment.get('progressEnd');
  const completedText = 'Completed';

  return getProgressHeadingText(progressValue, progressEnd, completedText);
}

export function getDeleteAssignmentModalHeading(assignmentToDelete) {
  return assignmentToDelete ? `Delete ${assignmentToDelete.get('name')}?` : 'Delete';
}

export function getDeleteAssignmentModalCopy(assignmentToDelete, classroomName) {
  let deleteMessage = 'Are you sure you want to delete this assignment?';
  /**
   * See XXX below.
   */
  deleteMessage += ` Deleting this assignment will remove it from ${
    classroomName || 'this classroom'
  }.`;

  if (assignmentToDelete) {
    /* XXX:
        Add this back, and update the incoming data to be  the # of students who have
        STARTED the assignment in the CURRENT CLASSROOM. For now, force this to interpolate an
        empty string.
    */
    // const studentsUsinngAssignment = assignmentToDelete.get('studentsInAssignment');
    const studentsUsingAssignment = null;
    // Interpolates is/are and class/classes depending on # of classes.
    const classesString = studentsUsingAssignment
      ? `${studentsUsingAssignment} ${
          studentsUsingAssignment === 1 ? `student has` : `students have`
        } completed or started this assignment. `
      : '';
    deleteMessage = classesString + deleteMessage;
  }

  return deleteMessage;
}
